import { render, staticRenderFns } from "./cashbox.vue?vue&type=template&id=146d0536&"
import script from "./cashbox.vue?vue&type=script&lang=js&"
export * from "./cashbox.vue?vue&type=script&lang=js&"
import style0 from "./cashbox.vue?vue&type=style&index=0&id=146d0536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports